export default {
  path: '/supervision',
  name: 'Supervision',
  redirect: '/supervision/indexSupervisionExpert',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'supervisoryExpert',
      component: () => import('@/views/center/infoSupervisionExpert'),
      meta: { requiresAuth: true }
    },
    {
      path: 'indexSupervisionExpert',
      component: () => import('@/views/center/indexSupervisionExpert'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionTrain',
      component: () => import('@/views/supervisory/supervisionTrain'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionMatch',
      component: () => import('@/views/supervisory/supervisionMatch'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionTrainAdd',
      component: () => import('@/views/supervisory/addSupervisionTrain'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionTrainEdit',
      component: () => import('@/views/supervisory/editSupervisionTrain'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionTrainView',
      component: () => import('@/views/supervisory/supervisionTrainDetails'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionMatchAdd',
      component: () => import('@/views/supervisory/addSupervisionMatch'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionMatchEdit',
      component: () => import('@/views/supervisory/editSupervisionMatch'),
      meta: { requiresAuth: true }
    },
    {
      path: 'supervisionMatchView',
      component: () => import('@/views/supervisory/supervisionMatchDetails'),
      meta: { requiresAuth: true }
    },
  ]
}
